module.exports = __webpack_public_path__ + "static/assets/66d6fe49aca21e23c39aa94dec7d147a.svg";